<template>
    <svg
        width="128"
        height="128"
        viewBox="0 0 128 128"
        fill="none"
        xmlns="http://www.w3.org/2000/svg">
        <path
            d="M35.8711 18.2295C36.6272 28.2492 38.2882 50.4319 39.2408 64.1726C41.6222 98.679 66.5792 93.7793 92.1375 93.8983"
            class="accent-stroke"
            stroke-width="7.73953"
            stroke-miterlimit="10" />
        <path
            d="M76.2829 62.464H41.7765C40.3725 62.464 39.2344 63.6021 39.2344 65.0061V65.0121C39.2344 66.4161 40.3725 67.5542 41.7765 67.5542H76.2829C77.6869 67.5542 78.8251 66.4161 78.8251 65.0121V65.0061C78.8251 63.6021 77.6869 62.464 76.2829 62.464Z"
            class="primary-stroke"
            stroke-width="2.08372"
            stroke-linecap="round"
            stroke-linejoin="round" />
        <path
            d="M73.2712 19.8369H70.0206C64.7301 19.8369 60.4414 24.1257 60.4414 29.4161V43.2103C60.4414 48.5007 64.7301 52.7895 70.0206 52.7895H73.2712C78.5616 52.7895 82.8503 48.5007 82.8503 43.2103V29.4161C82.8503 24.1257 78.5616 19.8369 73.2712 19.8369Z"
            class="primary-stroke"
            stroke-width="2.08372"
            stroke-linecap="round"
            stroke-linejoin="round" />
        <path
            d="M69.1037 19.8369H74.188C78.9687 19.8369 82.8503 23.7186 82.8503 28.4992H60.4414C60.4414 23.7186 64.3231 19.8369 69.1037 19.8369Z"
            class="primary-fill primary-stroke"
            stroke-width="2.08372"
            stroke-linecap="round"
            stroke-linejoin="round" />
        <path
            d="M92.1311 102.382H39.2344"
            class="primary-stroke"
            stroke-width="2.08372"
            stroke-linecap="round"
            stroke-linejoin="round" />
        <path
            d="M92.1311 109.77H39.2344"
            class="primary-stroke"
            stroke-width="2.08372"
            stroke-linecap="round"
            stroke-linejoin="round" />
    </svg>
</template>
